<template>
    <v-row justify="center" class="border-radius-3">
        <v-dialog v-model="dialog" persistent width="700" class="border-radius-3" hide-overlay>
            <v-card class="border-radius-3 pa-10">
                <v-card-title class=" d-flex justify-center mb-10"
                    ><span
                        class="titles text-h4 font-weight-medium primary--text py-3 d-flex justify-center"
                        >{{ greetWelcomeMessage }}</span
                    ></v-card-title
                >
                <v-card-subtitle class="px-10 "
                    ><span class="titles text-h6 font-weight-regular primary--text">{{
                        $t('initialTour.greet_text')
                    }}</span></v-card-subtitle
                >
                <v-card-text class=""
                    ><span class="primary--text subtitle-1 text-body-1">{{
                        $t('initialTour.greet_text_2')
                    }}</span></v-card-text
                >
                <v-card-actions class="d-flex justify-center">
                    <v-btn data-cy="continue-button-greet-modal" color="secondary px-15" large rounded @click="nextPass">{{
                        $t('initialTour.get_started')
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
/* eslint-disable no-nested-ternary */

import { mapState, mapActions } from 'vuex'
import initialReaderValidation from "../../mixins/InitialReaderValidation";

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            avatar: (state) => state.userData.avatarSelected,
            selectedCategories: (state) => state.userData.selectedCategories,
            survey: (state) => state.userData.survey,
            course: (state) => state.userData.user.course,
            testDiagnostic: (state) => state.dashboard.testDiagnostic,
        }),
        greetWelcomeMessage() {
            const genre =
                this.$i18n.locale === 'es' ? (this.user.genre === 'FEMALE' ? 'a' : 'o') : ''
            return `${this.$t('initialTour.greet_wellcome', {
                genre,
            })} ${this.$utils.upperFirstLetter(this.user.firstname.split(' ')[0])}!`
        },
    },
    methods: {
        ...mapActions('dashboard', [
            'showFirtsPass',
            'showAvatars',
            'showInitialPoll',
            'mountDiagnostic',
            'showFinishPreferencesModal',
            'showDiagnosticTutorialModal',
        ]),
        nextPass() {
            this.showFirtsPass()
            if (!this.avatar || !this.selectedCategories.length) {
                this.showAvatars()
                return
            }
            if (!this.isInitialReader && this.survey) {
                this.showFinishPreferencesModal()
                return
            }
            if (!this.isInitialReader && this.testDiagnostic && this.testDiagnostic.length) {
                this.showDiagnosticTutorialModal()
            }
        },
    },
    mixins: [initialReaderValidation]
}
</script>
<style>

</style>
